import { useEffect, useState } from "react";
import { API } from "../../Redux/actions/API";
import { useNavigate } from "react-router-dom";
import Table from "../Table/Table";
import Navbar from "../Navbar/Navbar";
import { useDispatch, useSelector } from "react-redux";
import { updateAuth } from "../../Redux/actions/AdminAuthSlice";
import { toast } from "react-toastify";
import axios from "axios";

export default function AdminBankDetails() {
  const { userId, jwt_token } = useSelector((state) => state.Auth);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [leftreferralApi, setleftreferralApi] = useState([]);
  const [imglink, setimglink] = useState("");
  const [upiid, setupiid] = useState("");
  const [type, setType] = useState("");

  const [btcaddress, setbtcaddress] = useState("");
  const [acholdername, setacholdername] = useState("");
  const [Bank_Name, setBank_Name] = useState("");
  const [Branch, setBranch] = useState("");
  const [ifsc, setifsc] = useState("");

  const [currentPage, setcurrentPage] = useState(1);
  const [listPerpage, setlistPerpage] = useState(10);
  const [isloading, setisloading] = useState(false);

  const referral_API = async () => {
    try {
      let responceRight = await API?.post(
        "/adminBankDetailsByBankidAdmin",
        {
          loginid: userId,
          action: 11,
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        },
      );
      //console.log("ewalletDetails", responceRight?.data?.data[0]);
      //   console.log("response", responceRight);
      responceRight = responceRight?.data?.data[0];
      setleftreferralApi([]);
      let arrayLeft = [];

      responceRight.forEach((item, index) => {
        arrayLeft.push({
          sr: index + 1,
          btcaddress: item?.btcaddress,
          acholdername: item?.acholdername,
          Bank_Name: item?.Bank_Name,
          Branch: item?.Branch,
          ifsc: item?.ifsc,
          edate: `${item?.edate}`,
        });
      });
      setleftreferralApi(arrayLeft);
    } catch (e) {
      console.log("error Balance APi", e);
      if (
        e.response.data.showableMessage ==
        "Please login to access this resource"
      ) {
        dispatch(updateAuth({ AdminAuth: false, jwt_token: "", userId: null }));
        sessionStorage.clear();
        localStorage.clear();
        navigate("/");
      }
    }
  };

  const OnhandleSubmit_API = async () => {
    try {
      setisloading(true);
      if (!acholdername) {
        toast.error("Enter Account Holder Name !!");
        setisloading(false);
        return;
      }
      if (!btcaddress) {
        toast.error("Enter Account No !!");
        setisloading(false);
        return;
      }
      if (!ifsc) {
        toast.error("Enter IFSC !!");
        setisloading(false);
        return;
      }
      if (!Bank_Name) {
        toast.error("Enter Valid IFSC !!");
        setisloading(false);
        return;
      }
      if (!Branch) {
        toast.error("Enter Valid IFSC !!");
        setisloading(false);
        return;
      }
      let responceRight = await API?.post(
        `updateDepositDetails`,
        {
          loginid: userId,
          btcAddress: btcaddress,
          bankname: Bank_Name,
          accountholdername: acholdername,
          ifsc: ifsc,
          branch: Branch,
          imglink: "",
          Type: 2,
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        },
      );
      //console.log("submit", responceRight?.data?.data);
      if (responceRight?.data?.data == "Success") {
        toast.success("Updated Successfully !!");
        referral_API();
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      } else {
        toast.error(responceRight?.data?.data);
        setisloading(false);
      }
    } catch (e) {
      setisloading(false);
      console.log("error directdeposite APi", e);
      if (
        e.response.data.showableMessage ==
        "Please login to access this resource"
      ) {
        dispatch(updateAuth({ AdminAuth: false, jwt_token: "" }));
        sessionStorage.clear();
        localStorage.clear();
        navigate("/");
      }
    }
  };

  useEffect(() => {
    referral_API();
  }, []);

  const GetBankByIFSC_API = async (IFSCode) => {
    try {
      let res = await axios.get(`https://ifsc.razorpay.com/${IFSCode}`);
      console.clear();
      console.log("res-->Bank", res);

      setBank_Name(res.data?.BANK);
      setBranch(res.data?.BRANCH);
    } catch (error) {
      console.log("Country API ERROR", error);
    }
  };
  useEffect(() => {
    GetBankByIFSC_API(ifsc);
  }, [ifsc]);

  const indexOfLastPost = currentPage * listPerpage;
  const indexOfFirstPage = indexOfLastPost - listPerpage;

  const currentPostleft = leftreferralApi.slice(
    indexOfFirstPage,
    indexOfLastPost,
  );

  var [my_team, set_my_team] = new useState({
    cols: [
      { Header: "S.No.", accessor: "sr" },
      { Header: "Account No.", accessor: "btcaddress" },
      { Header: "Acholder Name", accessor: "acholdername" },
      { Header: "Bank Name", accessor: "Bank_Name" },
      { Header: "Branch", accessor: "Branch" },
      { Header: "IFSC", accessor: "ifsc" },
      { Header: "Date ", accessor: "edate" },
    ],
  });

  return (
    <div>
      <Navbar />
      <div className="content-page">
        <div className="content">
          <div className="container">
            {/* <!-- Inline Form --> */}
            <div className="row">
              <div className="col-md-12">
                <div className="panel panel-primary">
                  <div className="panel-heading">
                    <h4 className="panel-title">Update Bank Details</h4>
                  </div>
                  <div
                    className="panel-body table-rep-plugin"
                    style={{ padding: "8px", overflowY: "scroll" }}
                  >
                    <div className="col-md-12">
                      <>
                        {" "}
                        <div className="row mb-5">
                          <form>
                            <div className="col-sm-4">
                              <input
                                className="form-control in-ip-1"
                                id="upiid"
                                onChange={(e) =>
                                  setacholdername(e.target.value)
                                }
                                placeholder="Account Holder Name"
                                type="text"
                                value={acholdername}
                                maxLength={100}
                              />
                            </div>
                            <div className="col-sm-4">
                              <input
                                className="form-control in-ip-1"
                                id="upiid"
                                onChange={(e) => setbtcaddress(e.target.value)}
                                placeholder="Account No."
                                type="text"
                                value={btcaddress}
                                maxLength={100}
                              />
                            </div>
                            <div className="col-sm-4">
                              <input
                                className="form-control in-ip-1"
                                id="upiid"
                                onChange={(e) => setifsc(e.target.value)}
                                placeholder="IFSC"
                                type="text"
                                value={ifsc}
                                maxLength={100}
                              />
                            </div>
                            <div className="col-sm-4">
                              <br />
                              <input
                                className="form-control in-ip-1"
                                id="upiid"
                                placeholder="Bank Name"
                                type="text"
                                value={Bank_Name}
                                disabled
                              />
                            </div>
                            <div className="col-sm-4">
                              <br />
                              <input
                                className="form-control in-ip-1"
                                id="upiid"
                                placeholder="Branch Name"
                                type="text"
                                value={Branch}
                                disabled
                              />
                            </div>

                            <div className="col-sm-4">
                              <br />
                              <input
                                type="button"
                                id="btnsearch"
                                onClick={() => OnhandleSubmit_API()}
                                className="btn btn-lg btn-primary"
                                disabled={isloading}
                                value={isloading ? "Processing.." : "Update"}
                              />
                            </div>
                          </form>
                        </div>
                      </>
                      <div className="row panel panel-primary">
                        <div className="panel-heading">
                          <h4 className="panel-title">Bank Account Details</h4>
                        </div>
                        <div
                          className="table-responsive"
                          data-pattern="priority-columns"
                          style={{ maxHeight: "500px", overflow: "scroll" }}
                        >
                          <Table
                            data={currentPostleft}
                            columns={my_team.cols}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
